import { ActionTree } from 'vuex'

import {
  getCarePlanDefinitions,
  getGenderDefinitions,
  getInsuranceCompaniesDefinitions,
  getRejectReasonsDefinitions,
  getServicesDefinitions,
} from '@/sdk/clients/DefinitionsClient'
import { RootState } from '@/store/types'

import { DefinitionsState, Mutations } from './types'

export default <ActionTree<DefinitionsState, RootState>>{
  async getAllDefinitions({ dispatch }) {
    await Promise.all([
      dispatch('getGenderDefinitions'),
      dispatch('getServicesDefinitions'),
      dispatch('getRejectReasonsDefinitions'),
      dispatch('getCarePlanDefinitions'),
      dispatch('getInsuranceCompaniesDefinitions'),
    ])
  },

  async getGenderDefinitions({ commit }) {
    commit(
      Mutations.SET_GENDER_DEFINITIONS,
      new Map((await getGenderDefinitions()).map(v => [v, v])),
    )
  },

  async getServicesDefinitions({ commit }) {
    commit(Mutations.SET_SERVICES_DEFINITIONS, await getServicesDefinitions())
  },

  async getRejectReasonsDefinitions({ commit }) {
    commit(
      Mutations.SET_REJECT_REASONS_DEFINITIONS,
      await getRejectReasonsDefinitions(),
    )
  },

  async getCarePlanDefinitions({ commit }) {
    commit(Mutations.SET_CARE_PLANS_DEFINITIONS, await getCarePlanDefinitions())
  },

  async getInsuranceCompaniesDefinitions({ commit }) {
    commit(
      Mutations.SET_INSURANCE_COMPANIES_DEFINITIONS,
      await getInsuranceCompaniesDefinitions(),
    )
  },
}
